/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {inject, InjectionToken} from "@angular/core";
import {AbstractRoleService} from "./abstract-role.service";
import {RoleService} from "./role.service";

export const ROLE_SERVICE_TOKEN =
  new InjectionToken<AbstractRoleService>('role_service_token', {
    factory: () => inject(RoleService)
  });
